import { create } from 'zustand';
import {
  forgetPendingCloneJob,
  readPendingCloneJobIds,
  rememberPendingCloneJob,
} from '@/Domain/components/Settings/ai/pendingCloneJobs';

// Module-scoped: a copy is queued from the sidebar but watched from the layout,
// which is the only tree that stays mounted while the mobile sidebar is closed.
interface CloneJobsStore {
  pendingJobIds: string[];
  rememberJob: (jobId: string) => void;
  forgetJob: (jobId: string) => void;
}

export const useCloneJobsStore = create<CloneJobsStore>((set) => ({
  pendingJobIds: readPendingCloneJobIds(),
  rememberJob: (jobId) =>
    set((state) => ({ pendingJobIds: rememberPendingCloneJob(state.pendingJobIds, jobId) })),
  forgetJob: (jobId) =>
    set((state) => ({ pendingJobIds: forgetPendingCloneJob(state.pendingJobIds, jobId) })),
}));
